(function(window, hotkeyServiceFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.hotkeyService = hotkeyServiceFactory();
})(this, function() {
   'use strict';

   var _hotkeysEnabled = true;

   var areHotkeysEnabled = function() {
      return _hotkeysEnabled;
   };

   var disableHotkeys = function() {
      _hotkeysEnabled = false;
   };

   var enableHotkeys = function() {
      _hotkeysEnabled = true;
   };

   return {
      areHotkeysEnabled: areHotkeysEnabled,
      disableHotkeys: disableHotkeys,
      enableHotkeys: enableHotkeys
   };
});
